//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import { Swiper, SwiperSlide } from "swiper/react";
//Install
import { Navigation, Pagination, Autoplay } from "swiper/modules";
//Install
import T052LZ from "../../../../Media/Image/028.jpg";
//Install
import C833IB from "../../../../Media/Image/037.jpg";
//Install
import Q71Q86 from "../../../../Media/Image/039.jpg";
//Install
import R79SK9 from "../../../../Media/Image/041.jpg";

//Element
class P57859 extends Component {
    //Element
    render() {
        //Element
        const C84K7A = {
            //Element
            spaceBetween: "0",
            //Element
            slidesPerView: "1",
            //Element
            autoplay: {
                //Element
                delay: 2500
            },
            //Element
            loop: true,
            //Element
            freeMode: true,
            //Element
            breakpoints: {
                //Element
                320: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                360: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                480: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                504: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                600: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                768: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1024: {
                    //Element
                    slidesPerView: 1
                },
                //Element
                1280: {
                    //Element
                    slidesPerView: 1
                }
            },
            //Element
            modules: [Navigation, Pagination, Autoplay]
        }
        //Element
        const Content = React.createElement(Row, {},
            //Element
            React.createElement(Col, { md: 4 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB f029qa" },
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q035zf" },
                        //Element
                        "01"
                    ),
                    //Element
                    React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB g371o1" },
                        //Element
                        "Elektriklə Toxunun, Gələcəyə Bağlanın."
                    ),
                    //Element
                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB tv2821" },
                        //Element
                        "Kəsintisiz Enerji, ",
                        //Element
                        React.createElement("br", {}),
                        //Element
                        React.createElement("em", {},
                            //Element
                            "Davamlı "
                        ),
                        //Element
                        React.createElement("br", {}),
                        //Element
                        "Gələcək"
                    )
                )
            ),
            //Element
            React.createElement(Col, { md: 8 },
                //Element
                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB j392d8" },
                    //Element
                    React.createElement(Swiper, { className: "S6pt64 C96Q4r pEO064 a527eB a129ro", ...C84K7A },
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Kəsintisiz Enerji, Davamlı Gələcək", title: "Kəsintisiz Enerji, Davamlı Gələcək", src: T052LZ, width: "856", height: "auto" })
                            )
                        ),
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Kəsintisiz Enerji, Davamlı Gələcək", title: "Kəsintisiz Enerji, Davamlı Gələcək", src: C833IB, width: "856", height: "auto" })
                            )
                        ),
                        //Element
                        React.createElement(SwiperSlide, {},
                            //Element
                            React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB u3177a" },
                                //Element
                                React.createElement("img", { alt: "Kəsintisiz Enerji, Davamlı Gələcək", title: "Kəsintisiz Enerji, Davamlı Gələcək", src: R79SK9, width: "856", height: "auto" })
                            )
                        )
                    ),
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB a725gw" },
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Temas Elektrik Müqaviləsi olaraq Elektriki Yalnız Köçürmürük, Gələcəyi Formalaşdırırıq. Elektrik Müqaviləsi, Baxım və Təmir, Layihə İnkişafı, Enerji Sistemləri və Avtomatlaşdırma Sahələrində Təcrübəli Komandamız və Yenilikçi Yanaşmamızla Həllər Təklif Edirik."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Dövlət Qurumlarından Sənaye Təsislərinə, KOBİ-lərdən Özəl Layihələrə qədər, Hər İşimizdə Davamlılıq, Keyfiyyət və Etibar Əsas Prioritetlərimizdir."
                        ),
                        //Element
                        React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB y48p90" },
                            //Element
                            "Bizim üçün Hər Kabel Bir Bağlantıdan Daha Çoxdur. Sabahı Bugünə Daşıyan Bir Xətdir, Təhlükəsiz və Sağlam Bir Tikilinin Təməlini Yaradır. Topladığımız Təcrübə və Müasir Yanaşmalarımızla Elektriki Davamlı İstifadə Edir və Hər İşimizi Gələcəyə Təhlükəsiz Daşınan Bir İnvestisiya Kimi Görürük."
                        ),
                        //Element
                        React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB q74b13", href: "/az/haqqimizda" },
                            //Element
                            "Haqqımızda"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default P57859;